const appState = window.expresoAppState

export function injectState (store) {
  store.commit('SET_LOCALE', appState.locale)
  store.commit('SET_EVENT_LOCALE', appState.eventLocale)
  store.commit('SET_PERMISSIONS', appState.permissions)
  store.commit('SET_ROUTE_NAME', appState.routeName)
  store.commit('SET_ROUTE_PARAMETERS', appState.routeParameters)
  store.commit('SET_CONFIG', appState.config)
}
